/**
 * Константы для OnRentedLoader
 */
export const ONRENTED_CONSTANTS = {
  MODEL_SCALE: 3,
  OBJECT_POSITION_Y: 3,

  OBJECT_ALTITUDE: 0,
  OBJECT_SCALE: 7,

  OBJECT_ID_PREFIX: 'onrented-',
} as const
